import Vue from 'vue'
import Vuex from 'vuex'
import { state, mutations } from './common'

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

Vue.config.devtools = true
Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  modules
})



// WEBPACK FOOTER //
// ./src/store/index.js